import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, params, onClickAction, enabled = true }) => {
  return (
    <Button
      color="primary"
      onClick={() => onClickAction(params)}
      disabled={!enabled}
    >
      <CheckBoxOutlined className={classes.leftIcon} />
      確認
    </Button>
  );
});

export default withStyles(styles)(button);
